import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowBack",
  "use": "arrowBack-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrowBack\">\n<path d=\"M13.3333 8.66683H5.21996L8.94663 12.3935L7.99996 13.3335L2.66663 8.00016L7.99996 2.66683L8.93996 3.60683L5.21996 7.3335L13.3333 7.3335V8.66683Z\" fill=\"#605E5C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol